import React from 'react';

import PropTypes from 'prop-types';

import { Video } from '~/techstyle-shared/react-components';

const getUrlFromVideoId = (videoId, defaultService = 'vimeo') => {
  const regexp = new RegExp('https?://');

  if (regexp.test(videoId)) {
    return videoId;
  }

  const [serviceName, id] = `${videoId}`.includes(':')
    ? videoId.split(':')
    : [defaultService, videoId];

  if (serviceName === 'vimeo') {
    return `https://vimeo.com/${id}`;
  } else if (serviceName === 'youtube') {
    return `https://www.youtube.com/watch?v=${id}`;
  }
};

// TODO: handle clickable asset card
const AssetCard = ({ imageFilename, options }) => {
  if (imageFilename) {
    return (
      <div className=" h-full">
        <img
          src={imageFilename}
          alt="Asset"
          className="w-full h-auto rounded-[12px]"
        />
      </div>
    );
  }

  // TODO: consider making cleaner video component and abstract away the parsing logic
  const videoId = options?.customVars?.videoId || options?.customVars?.VideoID;
  const videoUrl = getUrlFromVideoId(videoId);
  const aspectRatio = options?.customVars?.videoAspectRatio;
  if (videoId) {
    return <Video url={videoUrl} aspectRatio={aspectRatio} />;
  }

  // TODO: have a better fallback UI
  // Handle unsupported marketing asset types or missing user input (imageFilename | videoId)
  return (
    <div className="h-full flex flex-col justify-center items-center bg-gray-200">
      Marketing Asset Not available
    </div>
  );
};

AssetCard.propTypes = {
  imageFilename: PropTypes.string,
  options: PropTypes.shape({
    customVars: PropTypes.shape({
      videoId: PropTypes.string,
      VideoID: PropTypes.string,
      videoAspectRatio: PropTypes.number,
    }),
  }),
};

export default AssetCard;
